import { Model } from 'qn/data';
import { computed } from 'mobx';
import Channel from './Channel';

@Model({
  modelName: 'Agent',
  fields: {
    key: 'string',
    loginId: 'string',
    name: 'string',
    status: 'string',
    mail: 'string',
    phone: 'string',
    agentCode: 'string',
    agencyName: 'string',
    createdDate: 'date',
    id: 'number',
  },
  idProperty: 'key',
})
class Agent {
  constructor(data) {
    this.channels = data.channels.map(o => new Channel(o));
  }

  @computed get registeredChannels() {
    return this.channels.filter(o => o.hasPassedReview === true);
  }

  @computed get applyingChannels() {
    return this.channels.filter(o => o.hasPassedReview === false);
  }
}

export default Agent;
